import { ErrorPage, ErrorPageType } from '@exam-management/components';
import { Flex } from '@shared/components';

export default function UserNotActivePage() {
  return (
    <Flex sx={{ justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <ErrorPage errorType={ErrorPageType.USER_NOT_ACTIVE} />
    </Flex>
  );
}
